import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from '@rollbar/react';
import { getRollbarConfigFromEnv } from './services/rollbar/rollbarConfig';
import { RollbarErrorBoundary } from './services/rollbar/RollbarErrorBoundary';

const rollbarConfig = getRollbarConfigFromEnv();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider config={rollbarConfig}>
      <RollbarErrorBoundary>
        <App />
      </RollbarErrorBoundary>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
